import * as Yup from "yup";

export const RejectDocumentFormValidation = Yup.object({
  reason: Yup.string()
    .required("Reason is required")
    .min(1, "Too short")
    .max(3000, "Too long")
});
